import { EdgenDrawerCallableProps } from "../EdgenDrawerCallable";
import { SIGNAL_LEVELS } from "./const";
import { AlphaPickTAData } from "@/src/services/alphaPickServices";
import { AgentReport } from "@/src/features/api/memberApi";

export const TAListType = {
  US_Market: "US",
  HK_Market: "HK",
  Crypto: "Crypto",
} as const;

export type TAListType = (typeof TAListType)[keyof typeof TAListType];

export type TAFilterOption = "All" | "Watchlist";

export interface TAListProps {
  locale: string;
  type: TAListType;
  initialTAData?: AlphaPickTAData;
  /** 仅展示 Strong Buy 和 Strong Sell 信号 */
  filterStrongSignalsOnly?: boolean;
  /** 当前筛选；仅当为 Watchlist 且无数据、用户无关注时展示 Watchlist 空态 */
  filterOption?: TAFilterOption;
}

export interface TAListItemProps {
  data: AgentReport;
  onClick: (data: AgentReport) => void;
}

export interface TAModalCallableParams extends EdgenDrawerCallableProps {
  data: AgentReport;
  onClose?: () => void;
}

export interface TAGridProps {
  /** 新闻数据 */

  type: TAListType;

  locale: string;
  /** 项目宽度 */
  itemWidth?: number;
  /** 项目高度 */
  itemHeight?: number;
  /** 列间距 */
  columnGap?: number;
  /** 行间距 */
  rowGap?: number;
  /** 容器内边距 */
  padding?: number;
  /** 预加载项目数量，用于优化快速滚动性能 */
  preloadItemCount?: number;
  /** 是否启用无限滚动 */
  enableInfiniteScroll?: boolean;
  /** 容器类名 */
  className?: string;
  /** 容器样式 */
  style?: React.CSSProperties;
  initialTAData?: AlphaPickTAData;
  /** 仅展示 Strong Buy 和 Strong Sell 信号（与 TAList 对齐） */
  filterStrongSignalsOnly?: boolean;
  /** 当前筛选；仅当为 Watchlist 且无数据、用户无关注时展示 Watchlist 空态 */
  filterOption?: TAFilterOption;
  // deviceType: "mobile" | "desktop";
  // fetchNextPage: () => void;
  // hasNextPage: boolean;
  // isFetchingNextPage: boolean;
  // isLoading: boolean;
}

export type SignalLevelConfig = (typeof SIGNAL_LEVELS)[number];

export interface TADetailWebModalCreateAbleProps {
  data: AgentReport;
}
